import React, { Suspense, useEffect } from 'react'
import { Routes, Route, useParams } from 'react-router'

import { LazyLoadingMainComponent, LoadingRoute } from '../components/LazyComponent'

import { useSession } from '../providers/SessionProvider'

const AddMembers = React.lazy(() => import('../containers/AddMembers'))

const Members = React.lazy(() => import('../containers/Members'))

const NotFound = React.lazy(() => import('../components/templates/NotFound'))

const NotAuthorised = React.lazy(() => import('../containers/NotAuthorised'))

const TeamMember = () => {
  const { teamId } = useParams()
  const { setTeam, team, can, error } = useSession()

  useEffect(() => {
    setTeam({ teamId })
  }, [teamId])

  if (error?.type === 'Team')
    return (
      <Suspense fallback={<div />}>
        <NotFound id="team" />
      </Suspense>
    )

  if (team) {
    return (
      <Routes>
        <Route
          index
          element={
            <LazyLoadingMainComponent>
              <Members />
            </LazyLoadingMainComponent>
          }
        />
        <Route
          path="add"
          element={
            <LazyLoadingMainComponent>
              {can('updateOrganisations') ? <AddMembers /> : <NotAuthorised />}
            </LazyLoadingMainComponent>
          }
        />
      </Routes>
    )
  }
  return <LoadingRoute />
}

export default TeamMember
